export const generateTableHead = (accessExport) => {
  if (!accessExport) {
    return ['From', 'To', 'Users', 'Services', 'Status', 'Providers', 'Modes', 'Format', 'Created'];
  }

  return ['From', 'To', 'Users', 'Services', 'Status', 'Providers', 'Modes', 'Format', 'Created', ''];
};

export const makeTableRow = (item) => {
  const tableRow = [
    { value: item.from_date, type: 'from' },
    { value: item.to_date, type: 'to' },
    { value: item.users, type: 'users' },
    { value: item.services, type: 'services' },
    { value: item.statuses, type: 'status' },
    { value: item.providers, type: 'providers' },
    { value: item.mode, type: 'modes' },
    { value: item.format, type: 'format' },
    { value: item.date, type: 'created' },
    { value: item.id, type: 'id' },
  ];

  return tableRow;
};

export const validExportColumns = (export_columns = [], fields = {}) => export_columns.filter((item) => fields[item.id] === true || fields[item.id] === undefined);
